import { ExtendRightInvocationRequestBodyDTO } from '@ketch-com/figurehead'
import { extendRequestFormKeys } from './getValidationSchema'

export const getInitialValues = (): ExtendRightInvocationRequestBodyDTO => {
  return {
    [extendRequestFormKeys.extensionDays]: undefined,
    [extendRequestFormKeys.extensionReason]: undefined,
  }
}
